import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Thank() {
  useEffect(() => {
    AOS.init({ duration: 2000, once: true });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center">
      <div className="mb-6" data-aos="fade-up">
        <i className="fas fa-hand-holding-heart text-6xl text-green-400"></i>
      </div>
      <h1 className="text-4xl font-bold mb-4" data-aos="fade-up" data-aos-delay="200">
        Thank you for connecting.
      </h1>
      <p className="text-lg mb-8" data-aos="fade-up" data-aos-delay="400">
        We will get back to you ASAP. In the meantime, you can schedule a meeting if you want.
      </p>
      <Link to="/calender ">
        <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full mb-4" data-aos="fade-up" data-aos-delay="600">
          Pick A Time From Calendar
        </button>
      </Link>
      <Link to="/" className="text-green-400" data-aos="fade-up" data-aos-delay="800">
        Back To Home
      </Link>
    </div>
  );
}
